import React from 'react';
import { TableVirtuoso } from 'react-virtuoso';
import { Icon, Dropdown, Menu, Button, Input, Tooltip, Checkbox, Spin, Tag } from 'antd';
import Moment from 'react-moment';
import moment from 'moment';
import { toBRL } from '~/components/UI/InputCurrency';

var STATUS_CONFIG = {
    'Expirado': { color: '#f5222d', bg: '#fff1f0', border: '#ffa39e', label: 'Expirado' },
    'Expirando': { color: '#fa8c16', bg: '#fff7e6', border: '#ffd591', label: 'Expirando' },
    'Ativo': { color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f', label: 'Ativo' },
    'Arquivado': { color: '#8c8c8c', bg: '#fafafa', border: '#d9d9d9', label: 'Arquivado' },
    'pendent': { color: '#fa8c16', bg: '#fff7e6', border: '#ffd591', label: 'Pendente' },
};

var COL = {
    check: 32, status: 90, cod: 65, name: undefined, type: 100,
    emission: 100, due: 100, days: 70, amount: 100, nature: 70, actions: 50
};
var TABLE_W = Object.keys(COL).reduce(function(s, k) { return s + (COL[k] || 0); }, 0) + 250;

var thBase = {
    padding: '8px 10px', background: '#fafafa',
    borderTop: '1px solid #e8e8e8', borderBottom: '1px solid #e8e8e8',
    borderRight: '1px solid #f0f0f0',
    fontWeight: 600, textAlign: 'left', whiteSpace: 'nowrap',
    overflow: 'hidden', textOverflow: 'ellipsis', fontSize: 12,
    color: '#595959', textTransform: 'uppercase', letterSpacing: '0.03em'
};
var tdBase = {
    padding: '10px 10px',
    borderBottom: '1px solid #f0f0f0', borderRight: '1px solid #f5f5f5',
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 13,
    transition: 'background 0.15s'
};

var stickyLeftTh = { position: 'sticky', left: 0, zIndex: 3, borderLeft: '1px solid #e8e8e8' };
var stickyRightTh = { position: 'sticky', right: 0, zIndex: 3, boxShadow: '-3px 0 6px rgba(0,0,0,0.04)' };
var stickyLeftTd = { position: 'sticky', left: 0, zIndex: 2, borderLeft: '1px solid #f0f0f0' };
var stickyRightTd = { position: 'sticky', right: 0, zIndex: 2, boxShadow: '-3px 0 6px rgba(0,0,0,0.04)' };

function thS(w, extra) { var s = Object.assign({}, thBase, extra); if (w) s.width = w; return s; }
function tdS(w, extra) { var s = Object.assign({}, tdBase, extra); if (w) s.width = w; return s; }

var SORTERS = {
    name: function(a, b) {
        var ca = (a.customer_cod || '').toString();
        var cb = (b.customer_cod || '').toString();
        var c = ca.localeCompare(cb);
        if (c !== 0) return c;
        return (a.name || '').localeCompare(b.name || '');
    },
    emission_date: function(a, b) { return (a.emission_date || '').localeCompare(b.emission_date || ''); },
    due_date: function(a, b) { return (a.due_date || '').localeCompare(b.due_date || ''); },
    expires_in: function(a, b) { return (a.expires_in || 0) - (b.expires_in || 0); },
    amount: function(a, b) { return (parseFloat(a.amount) || 0) - (parseFloat(b.amount) || 0); }
};

/* ─── Status dot+text ─── */
function StatusDot(props) {
    var cfg = STATUS_CONFIG[props.state] || STATUS_CONFIG['Ativo'];
    return React.createElement('span', {
        style: { display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12 }
    },
        React.createElement('span', {
            style: {
                width: 8, height: 8, borderRadius: '50%', background: cfg.color,
                flexShrink: 0, boxShadow: '0 0 0 2px ' + cfg.bg
            }
        }),
        React.createElement('span', { style: { color: cfg.color, fontWeight: 500 } }, cfg.label)
    );
}

/* ─── Days progress bar ─── */
function DaysIndicator(props) {
    var days = props.days;
    var maxDays = 365;
    var pct = Math.min(Math.max(days / maxDays, 0), 1) * 100;
    var color = days <= 0 ? '#f5222d' : days <= 30 ? '#fa8c16' : days <= 90 ? '#fadb14' : '#52c41a';

    return React.createElement('div', {
        style: { display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'center' }
    },
        React.createElement('div', {
            style: {
                width: 28, height: 4, borderRadius: 2, background: '#f0f0f0',
                overflow: 'hidden', flexShrink: 0
            }
        },
            React.createElement('div', {
                style: { width: pct + '%', height: '100%', borderRadius: 2, background: color, transition: 'width 0.3s' }
            })
        ),
        React.createElement('span', {
            style: { fontSize: 12, fontWeight: 600, color: color, minWidth: 20, textAlign: 'right' }
        }, days)
    );
}

/* ─── Footer row count ─── */
function TableFooter(props) {
    var showing = props.showing;
    var total = props.total;
    var selected = props.selected;

    return React.createElement('div', {
        style: {
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '8px 12px', background: '#fafafa', borderTop: '1px solid #e8e8e8',
            fontSize: 12, color: '#8c8c8c'
        }
    },
        React.createElement('span', null,
            'Exibindo ',
            React.createElement('strong', { style: { color: '#262626' } }, showing),
            ' de ',
            React.createElement('strong', { style: { color: '#262626' } }, total),
            ' certificados'
        ),
        selected > 0 && React.createElement('span', null,
            React.createElement('strong', { style: { color: '#1890ff' } }, selected),
            ' selecionado' + (selected > 1 ? 's' : '')
        )
    );
}

var CertificatesTableList = React.memo(function CertificatesTableList(props) {
    var isLoading = props.isLoading;
    var filteredData = props.filteredData;
    var rowSelection = props.rowSelection;
    var onAction = props.onAction;
    var visualizationMode = props.visualizationMode;
    var findUser = props.findUser;
    var showEdit = props.showEdit;
    var parentStatusFilters = props.statusFilters || [];
    var parentTypeFilters = props.typeFilters || [];
    var parentNatureFilters = props.natureFilters || [];
    var totalCount = props.totalCount || 0;

    var sortState = React.useState('expires_in');
    var sortField = sortState[0]; var setSortField = sortState[1];
    var orderState = React.useState('ascend');
    var sortOrder = orderState[0]; var setSortOrder = orderState[1];
    var statusState = React.useState(null);
    var statusFilter = statusState[0]; var setStatusFilter = statusState[1];
    var empState = React.useState('');
    var empFilter = empState[0]; var setEmpFilter = empState[1];
    var empInputState = React.useState('');
    var empInput = empInputState[0]; var setEmpInput = empInputState[1];
    var empOpenState = React.useState(false);
    var empOpen = empOpenState[0]; var setEmpOpen = empOpenState[1];

    var processedData = React.useMemo(function() {
        var src = filteredData || [];
        var effectiveStatusFilters = parentStatusFilters.length > 0 ? parentStatusFilters : (statusFilter ? [statusFilter] : []);
        var hasStatus = effectiveStatusFilters.length > 0;
        var hasType = parentTypeFilters.length > 0;
        var hasNature = parentNatureFilters.length > 0;
        var hasEmp = !!empFilter;
        var ef = hasEmp ? empFilter.toLowerCase() : '';

        var result;
        if (!hasStatus && !hasType && !hasNature && !hasEmp) {
            result = src;
        } else {
            result = [];
            for (var i = 0, len = src.length; i < len; i++) {
                var r = src[i];
                if (hasStatus && effectiveStatusFilters.indexOf(r.state) === -1) continue;
                if (hasType && parentTypeFilters.indexOf(r.type) === -1) continue;
                if (hasNature && parentNatureFilters.indexOf(r.nature) === -1) continue;
                if (hasEmp) {
                    var nameMatch = r.name && r.name.toLowerCase().indexOf(ef) !== -1;
                    var codMatch = r.customer_cod && r.customer_cod.toLowerCase().indexOf(ef) !== -1;
                    if (!nameMatch && !codMatch) continue;
                }
                result.push(r);
            }
        }

        if (sortField && SORTERS[sortField]) {
            result = result.slice().sort(SORTERS[sortField]);
            if (sortOrder === 'descend') result.reverse();
        }
        return result;
    }, [filteredData, parentStatusFilters, parentTypeFilters, parentNatureFilters, statusFilter, empFilter, sortField, sortOrder]);

    function toggleSort(field) {
        if (sortField === field) {
            if (sortOrder === 'ascend') { setSortOrder('descend'); }
            else { setSortField(null); setSortOrder(null); }
        } else {
            setSortField(field); setSortOrder('ascend');
        }
    }

    function sortIcon(field) {
        if (sortField !== field) return React.createElement(Icon, { type: 'caret-down', style: { marginLeft: 4, fontSize: 10, opacity: 0.3 } });
        return React.createElement(Icon, { type: sortOrder === 'ascend' ? 'caret-up' : 'caret-down', style: { marginLeft: 4, fontSize: 10, color: '#1890ff' } });
    }

    var selectedKeys = rowSelection.selectedRowKeys;
    var selectedKeysSet = React.useMemo(function() { return new Set(selectedKeys); }, [selectedKeys]);
    var allChecked = processedData.length > 0 && selectedKeys.length === processedData.length;
    var someChecked = selectedKeys.length > 0 && !allChecked;

    function onToggleAll(e) {
        if (e.target.checked) {
            rowSelection.onChange(processedData.map(function(r) { return r.id; }));
        } else {
            rowSelection.onChange([]);
        }
    }
    function onToggleRow(id) {
        var idx = selectedKeys.indexOf(id);
        if (idx === -1) { rowSelection.onChange(selectedKeys.concat([id])); }
        else { rowSelection.onChange(selectedKeys.filter(function(k) { return k !== id; })); }
    }

    function handleRowClick(e, record) {
        // Don't trigger if clicking checkbox, actions, or links
        var tag = e.target.tagName;
        if (tag === 'INPUT' || tag === 'A' || tag === 'BUTTON') return;
        if (e.target.closest && (e.target.closest('.ant-dropdown-trigger') || e.target.closest('.ant-checkbox-wrapper') || e.target.closest('.row-quick-actions'))) return;
        if (showEdit) {
            showEdit(record);
        } else {
            onAction({ key: 'edit' }, record);
        }
    }

    function searchFilterDropdown() {
        return (
            <Dropdown
                visible={empOpen}
                onVisibleChange={setEmpOpen}
                trigger={['click']}
                overlay={
                    <div style={{ padding: 8, background: 'white', boxShadow: '0 2px 8px rgba(0,0,0,.15)', borderRadius: 4 }}
                         onClick={function(e) { e.stopPropagation(); }}>
                        <Input
                            placeholder="Filtrar por empresa"
                            value={empInput}
                            onChange={function(e) { setEmpInput(e.target.value); }}
                            onPressEnter={function() { setEmpFilter(empInput); setEmpOpen(false); }}
                            style={{ width: 250, marginBottom: 8, display: 'block' }}
                        />
                        <Button type="primary" onClick={function() { setEmpFilter(empInput); setEmpOpen(false); }}
                            icon="search" size="small" style={{ width: 120, marginRight: 8 }}>
                            Pesquisar
                        </Button>
                        <Button onClick={function() { setEmpFilter(''); setEmpInput(''); setEmpOpen(false); }}
                            size="small" style={{ width: 120 }}>
                            Limpar
                        </Button>
                    </div>
                }
            >
                <Icon type="search"
                    onClick={function(e) { e.stopPropagation(); }}
                    style={{ marginLeft: 4, color: empFilter ? '#1890ff' : '#bfbfbf', cursor: 'pointer', fontSize: 11 }}
                />
            </Dropdown>
        );
    }

    var dataRef = React.useRef({});
    dataRef.current = { processedData: processedData, onRowClick: handleRowClick };

    var tableComponents = React.useMemo(function() {
        return {
            Table: function(p) {
                return <table {...p} style={Object.assign({}, p.style, {
                    borderCollapse: 'separate', borderSpacing: 0, tableLayout: 'fixed', width: '100%', minWidth: TABLE_W
                })} />;
            },
            TableRow: function(p) {
                var d = dataRef.current;
                var idx = p['data-item-index'];
                var record = d.processedData[idx];
                var isEven = idx % 2 === 0;
                return <tr {...p}
                    style={Object.assign({}, p.style, { cursor: 'pointer' })}
                    className={'cert-row' + (isEven ? ' cert-row-even' : '') + (p.className ? ' ' + p.className : '')}
                    onClick={function(e) { if (record) d.onRowClick(e, record); }}
                />;
            }
        };
    }, []);

    var fixedHeaderContent = React.useCallback(function() {
        return (
            <tr>
                <th style={thS(COL.check, Object.assign({ textAlign: 'center', padding: '8px 4px' }, stickyLeftTh))}>
                    <Checkbox checked={allChecked} indeterminate={someChecked} onChange={onToggleAll} />
                </th>
                <th style={thS(COL.status)}>Status
                    <Dropdown trigger={['click']} overlay={
                        <Menu onClick={function(e) { setStatusFilter(e.key === 'all' ? null : e.key); }}>
                            <Menu.Item key="all">Todos</Menu.Item>
                            <Menu.Divider />
                            <Menu.Item key="Ativo">Ativo</Menu.Item>
                            <Menu.Item key="Expirando">Expirando</Menu.Item>
                            <Menu.Item key="Expirado">Expirado</Menu.Item>
                        </Menu>
                    }>
                        <Icon type="filter" style={{ marginLeft: 4, color: statusFilter ? '#1890ff' : '#bfbfbf', cursor: 'pointer', fontSize: 11 }} />
                    </Dropdown>
                </th>
                <th style={thS(COL.cod)}>Cód</th>
                <th style={thS(COL.name, { cursor: 'pointer' })} onClick={function() { toggleSort('name'); }}>
                    Nome {sortIcon('name')} {searchFilterDropdown()}
                </th>
                <th style={thS(COL.type)}>Tipo</th>
                <th style={thS(COL.emission, { cursor: 'pointer' })} onClick={function() { toggleSort('emission_date'); }}>
                    Emissão {sortIcon('emission_date')}
                </th>
                <th style={thS(COL.due, { cursor: 'pointer' })} onClick={function() { toggleSort('due_date'); }}>
                    Expiração {sortIcon('due_date')}
                </th>
                <th style={thS(COL.days, { cursor: 'pointer' })} onClick={function() { toggleSort('expires_in'); }}>
                    Dias {sortIcon('expires_in')}
                </th>
                <th style={thS(COL.amount, { cursor: 'pointer', textAlign: 'right' })} onClick={function() { toggleSort('amount'); }}>
                    Valor {sortIcon('amount')}
                </th>
                <th style={thS(COL.nature)}>Nat.</th>
                <th style={thS(COL.actions, Object.assign({ textAlign: 'center' }, stickyRightTh))}></th>
            </tr>
        );
    }, [allChecked, someChecked, sortField, sortOrder, statusFilter, empFilter]);

    function itemContent(index, record) {
        var isSelected = selectedKeysSet.has(record.id);
        var daysLeft = record.expires_in < 0 ? 0 : record.expires_in;
        var isEven = index % 2 === 0;
        var rowBg = isSelected ? '#e6f7ff' : (isEven ? '#fff' : '#fafbfc');

        return (
            <>
                <td style={tdS(COL.check, Object.assign({ textAlign: 'center', background: rowBg, padding: '10px 4px' }, stickyLeftTd))}>
                    <Checkbox checked={isSelected} onChange={function() { onToggleRow(record.id); }} />
                </td>
                <td style={tdS(COL.status, { background: rowBg })}>
                    <StatusDot state={record.status === 'pendent' ? 'pendent' : record.state} />
                </td>
                <td style={tdS(COL.cod, { background: rowBg, color: '#8c8c8c', fontSize: 12 })}>{record.customer_cod || ''}</td>
                <td style={tdS(COL.name, { background: rowBg, fontWeight: 500, color: '#262626' })}>
                    <Tooltip title={record.name} mouseEnterDelay={0.5}>
                        <span>{record.name || ''}</span>
                    </Tooltip>
                </td>
                <td style={tdS(COL.type, { background: rowBg, fontSize: 12, color: '#595959' })}>{record.type || ''}</td>
                <td style={tdS(COL.emission, { textAlign: 'center', background: rowBg, fontSize: 12 })}>
                    {record.emission_date && <Moment format="DD/MM/YYYY">{record.emission_date}</Moment>}
                </td>
                <td style={tdS(COL.due, { textAlign: 'center', background: rowBg, fontSize: 12 })}>
                    {record.due_date && <Moment format="DD/MM/YYYY">{record.due_date}</Moment>}
                </td>
                <td style={tdS(COL.days, { textAlign: 'center', background: rowBg })}>
                    <DaysIndicator days={daysLeft} />
                </td>
                <td style={tdS(COL.amount, { background: rowBg, textAlign: 'right', fontFamily: 'monospace', fontSize: 12, color: record.amount && parseFloat(record.amount) > 0 ? '#262626' : '#bfbfbf' })}>
                    {record.amount && parseFloat(record.amount) > 0 ? 'R$ ' + toBRL(record.amount) : '-'}
                </td>
                <td style={tdS(COL.nature, { background: rowBg, fontSize: 12, color: '#8c8c8c', textAlign: 'center' })}>
                    {record.nature || ''}
                </td>
                <td style={tdS(COL.actions, Object.assign({ textAlign: 'center', background: rowBg, padding: '4px' }, stickyRightTd))}>
                    <Tooltip title="Gerenciar">
                        <Button type="link" icon="setting" style={{ color: '#8c8c8c', padding: 0 }}
                            onClick={function(e) { e.stopPropagation(); onAction({ key: 'edit' }, record); }} />
                    </Tooltip>
                </td>
            </>
        );
    }

    if (!isLoading && processedData.length === 0) {
        var hasAnyFilter = !!statusFilter || !!empFilter || parentStatusFilters.length > 0 || parentTypeFilters.length > 0 || parentNatureFilters.length > 0;
        return (
            <div style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                padding: '60px 20px', background: '#fff', border: '1px solid #e8e8e8', borderRadius: 4,
            }}>
                <Icon
                    type={hasAnyFilter ? 'filter' : 'inbox'}
                    style={{ fontSize: 48, color: '#d9d9d9', marginBottom: 16 }}
                />
                <div style={{ fontSize: 16, color: '#595959', fontWeight: 500, marginBottom: 8 }}>
                    {hasAnyFilter ? 'Nenhum resultado encontrado' : 'Nenhum certificado digital'}
                </div>
                <div style={{ fontSize: 13, color: '#8c8c8c', textAlign: 'center', maxWidth: 320 }}>
                    {hasAnyFilter
                        ? 'Tente ajustar os filtros ou limpar a pesquisa para ver mais resultados.'
                        : 'Não há certificados digitais cadastrados para o período selecionado.'}
                </div>
            </div>
        );
    }

    return (
        <div>
            <style dangerouslySetInnerHTML={{ __html: '\n.cert-row:hover td { background: #f0f5ff !important; }\n.cert-row td { transition: background 0.15s; }\n' }} />
            <Spin spinning={isLoading}>
                <TableVirtuoso
                    style={{ height: 'calc(100vh - 340px)', border: '1px solid #e8e8e8', borderRadius: '4px 4px 0 0' }}
                    data={processedData}
                    components={tableComponents}
                    fixedHeaderContent={fixedHeaderContent}
                    itemContent={itemContent}
                    overscan={20}
                />
            </Spin>
            <TableFooter
                showing={processedData.length}
                total={totalCount || (filteredData && filteredData.length) || 0}
                selected={selectedKeys.length}
            />
        </div>
    );
});

export default CertificatesTableList;
